import React, { SVGProps } from 'react';

/* eslint-disable max-len */
const SvgSadSlightly: React.FunctionComponent<SVGProps<SVGSVGElement>> = props => (
  <svg viewBox="0 0 293 342" {...props}>
    <g fillRule="nonzero" fill="none">
      <path
        d="M223.66 333.1c0-6.88-31.91-13.25-71.28-13.25-39.36 0-71.27 5.27-71.27 12.14 0 6.88 31.9 9.65 71.27 9.65s71.28-1.67 71.28-8.55z"
        fill="#000"
        opacity={0.28}
      />
      <path
        d="M32.8 102.43s-42.99 78.48-8.95 88.36c0 0 12.92 1.17 10.9-12.43 0 0 14.46-1.56 9.67-14.17 0 0 15.48 1.48 15.97-15.53 0 0 .94-16.21-11.75-36.88 0 0-9.95-12.53-15.83-9.35z"
        fill="#FF7300"
      />
      <path
        d="M280.38 91.37c-1.26-4.38-2.86-11.74-3.53-16.26l-5.98-40.86c-.67-4.53-4.83-7.29-9.37-6.09l-14.04 3.8c-4.54 1.2-11.3.17-15.26-2.17 0 0-29.66-17.93-52.07-22-23.94-4.25-60.59 4.33-60.59 4.33-4.48 1.04-11.33-.2-15.24-2.7L92.42 1.9c-3.9-2.5-8.65-1.2-10.73 3.04L64.67 39.92c-2.02 4.08-5.8 10.54-8.45 14.4 0 0-22.61 32.23-27 57.01C17.08 180.9 64.9 247.34 136.1 259.9c71.04 12.5 138.72-33.81 150.86-103.38 4.63-25.94-6.58-65.15-6.58-65.15z"
        fill="#D85700"
      />
      <path
        d="M280.38 86.4c-1.26-4.14-2.86-11.1-3.53-15.37l-5.98-38.62c-.67-4.28-4.83-6.9-9.37-5.76l-14.04 3.6c-4.54 1.13-11.3.15-15.26-2.05 0 0-29.66-16.96-52.07-20.8-23.94-4.02-60.59 4.1-60.59 4.1-4.48.98-11.33-.2-15.24-2.56L92.42 1.82C88.52-.53 83.77.7 81.7 4.7L64.67 37.77c-2.02 3.85-5.8 9.96-8.45 13.6 0 0-22.61 30.47-27 53.9-3.56 19.25-3.24 40.97 2.6 61.8 2.66 9.53 6.85 18.78 11.56 27.49 3.24 5.99 49.04 52.28 103.12 52.28 54.08 0 89.35-9.58 115-35.75 12.86-13.12 20.1-29.67 24.3-49.11.53-2.5 1.7-8.18 2.1-13.26.31-3.82-.07-7.36 0-8.52 1.54-23.86-7.52-53.8-7.52-53.8z"
        fill="#FF7300"
      />
      <g transform="translate(167 78)">
        <circle cx={42.28} cy={41.46} r={41.44} fill="#D85700" />
        <circle fill="#FFF" cx={44.54} cy={43.94} r={41.44} />
      </g>
      <g transform="translate(69 68)">
        <circle cx={42.61} cy={42.97} r={42.01} fill="#D85700" />
        <circle fill="#FFF" cx={44.9} cy={45.45} r={42.01} />
      </g>
      <path
        d="M141.8 127.9c-1.15 7.05-7.9 11.86-14.94 10.7-7.05-1.14-11.87-7.9-10.72-14.94 1.16-7.05 7.9-11.86 14.95-10.71 7.05 1.15 11.87 7.9 10.71 14.95zM207.84 133.34c-1.15 7.05-7.9 11.86-14.95 10.7-7.04-1.14-11.86-7.9-10.7-14.94 1.14-7.05 7.9-11.86 14.94-10.71 7.05 1.15 11.86 7.9 10.71 14.95z"
        fill="#404040"
      />
      <path
        d="M133.3 162.74c5.36 2.56 18.29 11.32 21.48 18.75-.92 1.04 12.34-8.81 28.75-16.98 1.97-1.91-48.46-.47-50.24-1.77z"
        fill="#D85700"
      />
      <path d="M133.3 162.74c5.36 2.56 18.43 7.02 21.63 14.45l24.62-12.26s-44.48-.89-46.26-2.19z" fill="#F2F2F2" />
      <path fill="#404040" d="M173.59 164.27L156 170.74l-18.66-8z" />
      <path
        d="M132.65 162.64c0-2.5 13.14-11.91 28.37-22.76 0 0 9.6 15.93 22.35 23.5 0 0 2.81 1.7-14.77 2.6 0 0-26.29 3.29-35.95-3.34z"
        fill="#FFF"
      />
      <path
        d="M275.89 123.49s36.13 91.25.57 95.52c0 0-13.24-1.1-9.87-15.18 0 0-13.22-2.5-8.47-16.83 0 0-15.88-1.27-14.73-19.42 0 0 .6-17.4 15.5-37.04 0 0 11.33-11.5 17-7.05z"
        fill="#FF7300"
      />
      <path fill="#D85700" d="M75.1 94.34l46.47-22.27-7.6-24.57L75.11 60z" />
      <path fill="#FF7300" d="M54.24 101l87.26-40.56-27.53-15.94L75.11 57z" />
      <path fill="#D85700" d="M248.48 101.94l-43.54-23.91 21.93-1.2L246.61 98z" />
      <path fill="#FF7300" d="M267.87 111.7l-83.39-48.02L213.3 50.2l37.63 15.84z" />
    </g>
  </svg>
);
/* eslint-enable max-len */

export default SvgSadSlightly;
